<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>{{ $t('auth.register_title') }}</h1>
                <p class="text-muted">{{ $t('auth.register_description') }}</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"/></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input ref="name" type="text" class="form-control"
                                :placeholder=" $t('global.name') "
                                :class="{ 'is-invalid' : errorMsg.name }"
                                v-model="name"/>
                  <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
                </b-input-group>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"/></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control"
                                :placeholder=" $t('global.surname') "
                                :class="{ 'is-invalid' : errorMsg.surname }"
                                v-model="surname"/>
                  <div class="invalid-feedback" v-if="errorMsg.surname">{{ errorMsg.surname[0] }}</div>
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control"
                                :placeholder=" $t('global.email') "
                                :class="{ 'is-invalid' : errorMsg.email }"
                                v-model="email"/>
                  <div class="invalid-feedback" v-if="errorMsg.email">{{ errorMsg.email[0] }}</div>
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control"
                                :placeholder=" $t('global.password') "
                                :class="{ 'is-invalid' : errorMsg.password }"
                                v-model="password"/>
                  <div class="invalid-feedback" v-if="errorMsg.password">{{ errorMsg.password[0] }}</div>
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control" :placeholder=" $t('global.password_repeat') " :class="{ 'is-invalid' : errorMsg.password_confirmation }" v-model="password_confirmation"/>
                  <div class="invalid-feedback" v-if="errorMsg.password_confirmation">
                    {{ errorMsg.password_confirmation[0] }}
                  </div>
                </b-input-group>
                <b-button variant="success" block @click="register()">
                  {{ $t('auth.create_account') }}
                </b-button>
                <b-row>
                  <b-col cols="12" class="text-center">
                    <b-button variant="link" class="px-0"
                              :to="{ name: 'Login' }">
                      {{ $t('auth.already_have_account_link') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>:D

<script>
import Services from '@/services/index';

export default {
  mounted() {
    this.$refs.name.$el.focus();
  },
  data() {
    return {
      name: '',
      surname: '',
      email: '',
      password: '',
      password_confirmation: '',
      errorMsg: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    register() {
      Services.auth.register(this.$data).then((data) => {
        this.errorMsg = {};
        this.$router.push({ name: 'Login' });
      }).catch(({ errors, message }) => {
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    }
  }
};

</script>
